import AiChatbotPage from "@components/new-ui/AiChatbot/AiChatbotPage";
import NewLayout from "@components/new-ui/Layout";
import React from "react";

const AiPage: React.FC = () => {
    return (
        <NewLayout
            title="Gallabox Gen AI: Harness the power of AI WhatsApp Chatbot | Gallabox"
            description="Access the limitless power of AI, right inside Gallabox. Respond faster, communicate effectively, and make an impact with WhatsApp AI Chatbot"
            canonical="https://gallabox.com/whatsapp-ai-chatbot"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ai/ai-og-revised.png" }}
        >
            <AiChatbotPage />
        </NewLayout>
    );
};

export default AiPage;
